@if (this.paymentInfo != null) {
    <hr>
    <div>
        <label class="header-label">Payment info:</label>
        <label style="font-size: 12px; margin-left: 20px">{{paymentInfo?.paymentId}}</label>
        <table>
            <tr>
                <td>Due date:</td>
                <td>{{paymentInfo?.paymentDate}}</td>
                <td>Terms:</td>
                <td>{{paymentInfo?.terms}} months</td>
                <td>Pricing Method:</td>
                <td>{{PricingMethods[paymentInfo?.pricingMethod]}}</td>
                <td>Stations:</td>
                <td>{{paymentInfo?.stations}}</td>
            </tr>
            <tr>
                <td>Amount:</td>
                <td>${{paymentInfo?.amountBefore}}</td>
                @if (paymentInfo?.discount > 0) {
                    <td>Discount:</td>
                    <td>{{paymentInfo?.discount}}%</td>
                    <td>Amount after discount:</td>
                    <td>${{paymentInfo?.amount}}</td>
                }
            </tr>
        </table>
    </div>
    <hr>
    @if (!paid) {
        <div style="width: 100%; text-align: center;">
            <button style="width: 200px; height: 60px; color: white; background-color: green" (click)="onMakePayment()" class="subButton" mat-raised-button [disabled]="!canMakePayment()">Make payment</button>
        </div>
    }
    @else {
        <div style="width: 100%; text-align: center; font-size: 24px; color: green; font-weight: bold;">Payment succeeded</div>
    }

}
